var map = {
	"./amex.png": 2752,
	"./bank-account.png": 47505,
	"./card.png": 85659,
	"./credit-card.png": 28031,
	"./diners-club.png": 96309,
	"./discover.png": 33900,
	"./jcb.png": 51272,
	"./mastercard.png": 17649,
	"./unionpay.png": 78436,
	"./visa.png": 22438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81254;